import { render, staticRenderFns } from "./EditItem.vue?vue&type=template&id=7a2e95d4&scoped=true&"
import script from "./EditItem.vue?vue&type=script&lang=ts&"
export * from "./EditItem.vue?vue&type=script&lang=ts&"
import style0 from "./EditItem.vue?vue&type=style&index=0&id=7a2e95d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2e95d4",
  null
  
)

export default component.exports